<klt-header-tab [links]="links"></klt-header-tab>
<div class="financials--content">
  <router-outlet></router-outlet>
</div>
